export default __webpack_public_path__ + "static/media/gallery22.17a4230b.webp";